import { BrowserRouter } from "react-router-dom";
import CentralRouter from "./routers";
import { Provider } from "react-redux";
import { createAppStore } from "./store";
import { App } from "antd";
import "./App.scss";

function MitigatorApp() {
  return (
    <App className="col w-100 h-100 o-hide">
      <Provider store={createAppStore()}>
        <BrowserRouter>
          <CentralRouter />
        </BrowserRouter>
      </Provider>
    </App>
  );
}

export default MitigatorApp;
